import React from "react";
import OfficeSpace from "./components/office-space/OfficeSpace";

const OfficeSpacePage = () => {
  return (
    <div>
      <OfficeSpace />
    </div>
  );
};

export default OfficeSpacePage;
